import Vue from 'vue';

Vue.directive('focus', {
    inserted: el => el.focus(),
});



// WEBPACK FOOTER //
// ./resources/js/modules/enso/directives/focus.js